<template>
	<div class="product flex-center">
		<c-image :src="oss(image, imageSize, imageSize)" :size="imageSize" preview></c-image>
		<p class="flex-grow ellipsis-2" style="margin-left: 12px;">{{name}}</p>
	</div>
</template>

<script>
	export default {
		props: {
			image: String,
			
			imageSize: {
				type: [Number, String],
				default: 46
			},
			
			name: String
		}
	}
</script>

<style lang="stylus" scoped>
</style>
